module.exports = __webpack_public_path__ + "static/media/in-progress.39630f20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/importRegistryAccountPage/in-progress.svg
// module id = 2664
// module chunks = 51